function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerformanceTestPreState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9257 -0.3782 0.3782 0.9257 -62.092 191.7771)",
    style: {
      fill: "#C0CFDF"
    },
    cx: 457.214,
    cy: 253.973,
    rx: 19.423,
    ry: 19.423
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9239 -0.3827 0.3827 0.9239 -51.3416 26.1498)",
    style: {
      fill: "#C0CFDF"
    },
    cx: 40.061,
    cy: 142.131,
    rx: 12.555,
    ry: 12.555
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9924 -0.1233 0.1233 0.9924 -8.3072 48.9084)",
    style: {
      fill: "#C0CFDF"
    },
    cx: 390.858,
    cy: 91.548,
    rx: 38.92,
    ry: 38.92
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C0CFDF"
    },
    d: "M64.057,448.965h354.692c15.976-10.664,38.703-22.93,47.212-47.786 c20.15-58.857-27.298-79.804-53.137-108.975c-25.838-29.171,27.63-41.252,20.479-104.063 c-3.678-32.309-46.857-61.837-91.02-46.308c-44.163,15.529-50.571-2.952-71.041-40.618 c-23.796-43.786-125.447-67.536-184.374,11.155c-58.927,78.692-2.083,138.316-8.748,166.458 c-6.664,28.142-54.146,42.649-57.535,96.809C18.622,407.021,30.221,435.112,64.057,448.965z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7B8FB4",
      strokeMiterlimit: 10
    },
    d: "M107.821,446.347c6.882-4.907,7.56-36.031-20.647-42.33 c-14.405-3.217-12.098-10.428-15.009-19.704c-2.911-9.276-6.563-9.958-14.809-11.217c-8.246-1.259-2.055-12.499-11.842-19.008 c-9.788-6.509-22.925-7.009-27.82,7.218c-4.143,12.045,7.594,17.351,9.988,22.952c2.394,5.602-4.57,13.164,3.922,21.611 c8.492,8.447,17.576,2.089,17.687,11.034c0.111,8.945,4.086,25.244,12.709,28.597 C72.666,449.647,102.389,450.22,107.821,446.347z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B8FB4"
    },
    d: "M99.293,448.832c-3.757-4.483-7.66-8.849-11.427-13.326 c-9.372-11.14-18.527-22.464-27.471-33.95c-6.64-8.528-13.156-17.152-19.536-25.875c-0.564-0.771-1.866-0.024-1.295,0.757 c10.596,14.486,21.565,28.699,32.844,42.66c7.145,8.844,14.408,17.593,21.833,26.203c1.324,1.535,2.689,3.038,3.991,4.591 C98.853,450.634,99.909,449.568,99.293,448.832L99.293,448.832z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B8FB4"
    },
    d: "M38.79,398.824c5.667,0.201,11.305,0.1,16.945-0.517c0.949-0.104,0.96-1.605,0-1.5 c-5.641,0.617-11.279,0.718-16.945,0.517C37.825,397.29,37.826,398.79,38.79,398.824L38.79,398.824z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B8FB4"
    },
    d: "M83.316,429.799c1.876-6.259,2.975-12.724,3.289-19.251c0.046-0.965-1.454-0.962-1.5,0 c-0.308,6.397-1.397,12.717-3.235,18.852C81.591,430.327,83.039,430.723,83.316,429.799L83.316,429.799z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7B8FB4",
      strokeMiterlimit: 10
    },
    d: "M76.891,398.846c0.747-6.137,2.044-14.826,2.596-20.417 c2.248-22.731-35.838-16.268-48.316-45.437c-12.479-29.169,29.571-28.419,10.46-48.279 c-18.075-18.784-18.039-53.242,1.899-63.108c27.727-13.721,52.57,9.499,55.903,32.029c2.571,17.378-9.081,29.514,21.242,42.253 c30.323,12.739,25.638,28.558,19.409,58.814c-6.229,30.255,14.263,19.162,30.189,44.701 c12.62,20.238-5.115,40.879-13.023,48.577l-61.375,1.054"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B8FB4"
    },
    d: "M146.153,447.155c-0.665-1.535-1.332-3.07-1.998-4.604c-1.824-4.199-3.651-8.396-5.479-12.593 c-2.744-6.297-5.492-12.591-8.245-18.884c-3.442-7.868-6.89-15.733-10.346-23.595c-3.868-8.799-7.745-17.595-11.634-26.386 c-4.088-9.241-8.188-18.477-12.306-27.706c-4.03-9.031-8.076-18.056-12.147-27.068c-3.765-8.335-7.551-16.66-11.377-24.967 c-3.222-6.996-6.47-13.98-9.785-20.932c-2.458-5.155-4.94-10.302-7.56-15.377c-0.465-0.899-0.934-1.796-1.412-2.688 c-0.456-0.851-1.751-0.095-1.295,0.757c2.42,4.517,4.669,9.127,6.898,13.741c3.161,6.544,6.244,13.125,9.301,19.719 c3.708,7.998,7.372,16.017,11.013,24.046c4.047,8.923,8.066,17.86,12.067,26.804c4.114,9.196,8.209,18.401,12.291,27.612 c3.98,8.981,7.948,17.969,11.906,26.96c3.572,8.116,7.137,16.236,10.694,24.358c2.957,6.753,5.91,13.509,8.857,20.267 c2.076,4.761,4.15,9.523,6.221,14.286c0.97,2.231,1.844,4.54,2.919,6.723c0.046,0.092,0.082,0.19,0.124,0.285 C145.24,448.796,146.533,448.033,146.153,447.155L146.153,447.155z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B8FB4"
    },
    d: "M88.821,318.561c-11.992-0.663-23.984-1.327-35.976-1.99 c-1.725-0.095-3.449-0.191-5.174-0.286c-0.965-0.053-0.962,1.447,0,1.5c11.992,0.663,23.984,1.327,35.976,1.99 c1.725,0.095,3.449,0.191,5.174,0.286C89.785,320.115,89.782,318.614,88.821,318.561L88.821,318.561z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B8FB4"
    },
    d: "M130.37,412.285c-8.811-0.991-17.622-1.982-26.433-2.973 c-1.262-0.142-2.524-0.284-3.785-0.426c-0.958-0.108-0.95,1.393,0,1.5c8.811,0.991,17.622,1.982,26.433,2.973 c1.262,0.142,2.524,0.284,3.785,0.426C131.328,413.893,131.32,412.392,130.37,412.285L130.37,412.285z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B8FB4"
    },
    d: "M132.82,310.181c-2.73,6.128-5.46,12.256-8.19,18.385c-4.332,9.723-8.663,19.447-12.995,29.17 c-0.998,2.24-1.995,4.479-2.993,6.719c-0.389,0.874,0.903,1.638,1.295,0.757c2.73-6.128,5.46-12.257,8.19-18.385 c4.332-9.723,8.663-19.447,12.995-29.17c0.998-2.24,1.995-4.479,2.993-6.719C134.505,310.064,133.212,309.3,132.82,310.181 L132.82,310.181z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7B8FB4",
      strokeMiterlimit: 10
    },
    d: "M41.576,261.42c2.012,2.956,5.516,4.078,7.826,2.506 c2.309-1.572,2.55-5.243,0.538-8.199c-2.012-2.956-5.516-4.078-7.826-2.506C39.805,254.793,39.564,258.464,41.576,261.42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7B8FB4",
      strokeMiterlimit: 10
    },
    d: "M56.13,270.457c0,1.563,1.267,2.829,2.829,2.829 c1.563,0,2.829-1.266,2.829-2.829s-1.267-2.829-2.829-2.829C57.397,267.628,56.13,268.894,56.13,270.457z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7B8FB4",
      strokeMiterlimit: 10
    },
    d: "M403.554,428.179c1.334-2.96-7.361-15.936,2.902-20.773 c10.262-4.838,11.061-16.946,11.061-16.946c0.497-4.621,0.811-9.19,1.357-13.379c2.222-17.029,29.014-5.815,43.116-25.053 c14.103-19.238-16.82-25.844,0.555-37.136c16.434-10.681,22.271-35.921,9.349-46.54c-17.97-14.767-40.115-1.989-46.39,13.943 c-4.84,12.289,1.627,23.159-22.747,27.329c-24.374,4.169-23.635,16.551-24.222,39.768c-0.587,23.217-14.583,6.775-30.592,22.767 c-12.686,12.673-9.371,30.244-4.891,37.227c0,0,2.81,11.202-2.729,17.909c-5.538,6.707-28.194,6.389-24.558,20.24"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B8FB4"
    },
    d: "M353.686,449.344c2.982-4.861,5.978-9.712,8.977-14.562 c7.375-11.928,14.781-23.837,22.22-35.725c9.353-14.946,18.758-29.861,28.254-44.717 c9.056-14.169,18.179-28.299,27.538-42.27c6.259-9.342,12.464-18.871,19.575-27.598c0.486-0.596,0.979-1.185,1.486-1.763 c0.634-0.723-0.423-1.788-1.061-1.061c-2.726,3.111-5.174,6.475-7.596,9.823c-3.645,5.039-7.168,10.167-10.654,15.318 c-9.18,13.563-18.089,27.308-26.932,41.091c-9.643,15.029-19.183,30.123-28.668,45.252 c-7.817,12.467-15.595,24.958-23.34,37.471c-2.483,4.011-4.962,8.024-7.436,12.04c-1.165,1.89-2.46,3.751-3.512,5.708 c-0.044,0.081-0.097,0.159-0.146,0.237C351.885,449.412,353.182,450.166,353.686,449.344L353.686,449.344z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B8FB4"
    },
    d: "M421.42,342.227c8.909,1.557,17.818,3.115,26.727,4.672c1.265,0.221,2.53,0.442,3.795,0.663 c0.944,0.165,1.349-1.28,0.399-1.447c-8.909-1.557-17.818-3.115-26.727-4.672c-1.265-0.221-2.53-0.442-3.795-0.663 C420.875,340.615,420.469,342.06,421.42,342.227L421.42,342.227z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B8FB4"
    },
    d: "M385.152,397.794c7.119,0.832,14.238,1.664,21.356,2.495 c1.011,0.118,2.021,0.236,3.032,0.354c0.957,0.112,0.949-1.389,0-1.5c-7.119-0.832-14.237-1.664-21.356-2.495 c-1.011-0.118-2.021-0.236-3.032-0.354C384.195,396.182,384.203,397.683,385.152,397.794L385.152,397.794z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B8FB4"
    },
    d: "M391.805,328.497c0.955,4.944,1.909,9.887,2.864,14.831c1.521,7.875,3.042,15.75,4.563,23.625 c0.348,1.801,0.696,3.603,1.044,5.404c0.183,0.947,1.629,0.546,1.446-0.399c-0.955-4.944-1.909-9.887-2.864-14.831 c-1.521-7.875-3.042-15.75-4.563-23.625c-0.348-1.801-0.696-3.603-1.044-5.404 C393.068,327.151,391.622,327.552,391.805,328.497L391.805,328.497z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B8FB4"
    },
    d: "M360.658,375.53c0.993,5.141,1.986,10.283,2.979,15.424 c1.592,8.244,3.184,16.488,4.777,24.733c0.364,1.887,0.729,3.773,1.093,5.66c0.183,0.947,1.629,0.546,1.446-0.399 c-0.993-5.141-1.986-10.283-2.979-15.424c-1.592-8.244-3.184-16.488-4.777-24.733c-0.364-1.887-0.729-3.773-1.093-5.66 C361.921,374.184,360.475,374.585,360.658,375.53L360.658,375.53z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7B8FB4",
      strokeMiterlimit: 10
    },
    d: "M444.352,282.83c-1.977,1.822-4.734,2.048-6.158,0.504 c-1.424-1.544-0.976-4.274,1.001-6.096c1.977-1.823,4.734-2.048,6.157-0.504C446.777,278.278,446.329,281.008,444.352,282.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7B8FB4",
      strokeMiterlimit: 10
    },
    d: "M442.714,294.787c-0.266,1.144-1.409,1.856-2.553,1.59 c-1.144-0.266-1.857-1.409-1.591-2.553c0.266-1.144,1.409-1.856,2.553-1.59C442.267,292.499,442.979,293.642,442.714,294.787z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7B8FB4",
      strokeMiterlimit: 10
    },
    d: "M449.26,448.193c0.829-5.144,0.249-10.702,0.344-15.488 c0.206-10.353,15.906-3.593,24.171-15.799c8.265-12.206-7.002-19.109,1.219-23.573c8.221-4.465,12.293-21.136,2.326-27.71 c-12.323-8.129-27.447-0.165-30.547,9.706c-2.391,7.614,2.942,13.876-13.622,17.458c-16.563,3.582-15.081,11.007-13.67,25.015 c1.412,14.008-8.998,2.504-18.838,12.839c-5.577,5.857-2.015,13.899,1.195,18.902"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B8FB4"
    },
    d: "M418.288,449.92c6.931-10.077,13.883-20.14,20.877-30.173 c7.842-11.25,15.71-22.487,23.794-33.564c2.948-4.039,5.89-8.104,9.075-11.962c0.61-0.739-0.445-1.806-1.061-1.061 c-6.727,8.147-12.737,16.937-18.849,25.545c-8.262,11.636-16.414,23.351-24.532,35.087 c-3.541,5.119-7.073,10.243-10.6,15.371C416.444,449.96,417.744,450.711,418.288,449.92L418.288,449.92z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B8FB4"
    },
    d: "M448.324,406.283c6.285,0.546,12.569,1.091,18.854,1.637 c0.905,0.078,1.809,0.157,2.714,0.236c0.961,0.083,0.956-1.417,0-1.5c-6.285-0.546-12.57-1.091-18.854-1.637 c-0.905-0.078-1.809-0.157-2.714-0.236C447.362,404.699,447.368,406.2,448.324,406.283L448.324,406.283z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B8FB4"
    },
    d: "M424.879,398.668c2.718,7.606,5.436,15.213,8.153,22.819c0.384,1.075,0.768,2.149,1.152,3.224 c0.322,0.902,1.772,0.513,1.446-0.399c-2.718-7.606-5.436-15.213-8.153-22.819c-0.384-1.075-0.768-2.149-1.152-3.224 C426.003,397.367,424.553,397.756,424.879,398.668L424.879,398.668z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7B8FB4",
      strokeMiterlimit: 10
    },
    d: "M459.877,374.824c-1.227,1.184-3.12,1.441-4.227,0.574 c-1.108-0.867-1.011-2.531,0.216-3.715c1.227-1.184,3.12-1.441,4.227-0.574C461.201,371.976,461.104,373.639,459.877,374.824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7B8FB4",
      strokeMiterlimit: 10
    },
    d: "M465.942,416.268c-0.184,1.362-1.615,2.293-3.196,2.079 c-1.581-0.213-2.714-1.49-2.53-2.852c0.184-1.362,1.615-2.293,3.196-2.079C464.993,413.629,466.126,414.906,465.942,416.268z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7B8FB4",
      strokeMiterlimit: 10
    },
    d: "M202.353,448.193c0.829-5.144,0.239-9.197,0.334-13.983 c0.206-10.353,17.622-3.208,25.887-15.414c8.265-12.206-6.529-22.457,2.498-24.916c21.912-5.969,13.159-30.244,2.063-36.923 c-12.648-7.613-32.796-1.196-35.471,13.249c-1.453,7.847,5.144,18.999-11.419,22.581c-9.317,2.015-12.924,5.246-14.046,10.18"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B8FB4"
    },
    d: "M171.38,449.92c6.931-10.077,13.883-20.14,20.877-30.173 c7.842-11.25,15.71-22.487,23.794-33.564c2.948-4.039,5.89-8.104,9.075-11.962c0.61-0.739-0.445-1.806-1.061-1.061 c-6.727,8.147-12.737,16.937-18.849,25.545c-8.262,11.636-16.414,23.351-24.532,35.087 c-3.541,5.119-7.073,10.243-10.6,15.371C169.537,449.96,170.836,450.711,171.38,449.92L171.38,449.92z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B8FB4"
    },
    d: "M201.417,406.283c6.285,0.546,12.57,1.091,18.854,1.637c0.905,0.078,1.809,0.157,2.714,0.236 c0.961,0.083,0.956-1.417,0-1.5c-6.285-0.546-12.57-1.091-18.854-1.637c-0.905-0.078-1.809-0.157-2.714-0.236 C200.455,404.699,200.461,406.2,201.417,406.283L201.417,406.283z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B8FB4"
    },
    d: "M177.971,398.668c2.718,7.606,5.436,15.213,8.153,22.819c0.384,1.075,0.768,2.149,1.152,3.224 c0.322,0.902,1.772,0.513,1.446-0.399c-2.718-7.606-5.436-15.213-8.153-22.819c-0.384-1.075-0.768-2.149-1.152-3.224 C179.095,397.367,177.645,397.756,177.971,398.668L177.971,398.668z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7B8FB4",
      strokeMiterlimit: 10
    },
    d: "M212.969,374.824c-1.227,1.184-3.12,1.441-4.227,0.574 c-1.108-0.867-1.011-2.531,0.216-3.715c1.227-1.184,3.12-1.441,4.227-0.574C214.293,371.976,214.196,373.639,212.969,374.824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7B8FB4",
      strokeMiterlimit: 10
    },
    d: "M219.035,416.268c-0.184,1.362-1.615,2.293-3.196,2.079 c-1.581-0.213-2.714-1.49-2.53-2.852c0.184-1.362,1.615-2.293,3.196-2.079C218.086,413.629,219.218,414.906,219.035,416.268z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C4465"
    },
    d: "M232.154,245.518c0,5.358,0,10.715,0,16.073c0,12.779,0,25.558,0,38.336 c0,15.535,0,31.071,0,46.606c0,13.361,0,26.722,0,40.083c0,6.52-0.174,13.066,0,19.584c0.002,0.09,0,0.18,0,0.269 c0,1.891,1.609,3.5,3.5,3.5c1.898,0,3.5-1.602,3.5-3.5c0-5.358,0-10.715,0-16.073c0-12.779,0-25.558,0-38.336 c0-15.535,0-31.071,0-46.606c0-13.361,0-26.722,0-40.083c0-6.52,0.174-13.066,0-19.584c-0.002-0.09,0-0.18,0-0.269 c0-1.891-1.609-3.5-3.5-3.5C233.756,242.018,232.154,243.62,232.154,245.518L232.154,245.518z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C4465"
    },
    d: "M240.527,409.774h-9.744c-1.972,0-3.57-1.598-3.57-3.57v-9.745c0-1.972,1.598-3.57,3.57-3.57 h9.744c1.972,0,3.57,1.599,3.57,3.57v9.745C244.097,408.176,242.498,409.774,240.527,409.774z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C4465"
    },
    d: "M233.276,406.469c0,11.771,0,23.543,0,35.314c0,1.649,0,3.298,0,4.948c0,3.217,5,3.223,5,0 c0-11.771,0-23.543,0-35.314c0-1.649,0-3.298,0-4.947C238.276,403.252,233.276,403.247,233.276,406.469L233.276,406.469z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C4465"
    },
    d: "M232.586,406.096c-5.48,4.401-10.96,8.802-16.441,13.203 c-8.656,6.952-17.313,13.903-25.969,20.855c-1.996,1.603-3.992,3.206-5.989,4.809c-1.054,0.846-0.882,2.654,0,3.535 c1.041,1.041,2.479,0.848,3.536,0c5.48-4.401,10.96-8.802,16.441-13.203c8.656-6.952,17.313-13.903,25.969-20.855 c1.996-1.603,3.993-3.206,5.989-4.809c1.054-0.846,0.882-2.654,0-3.535C235.08,405.055,233.642,405.248,232.586,406.096 L232.586,406.096z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C4465"
    },
    d: "M235.187,409.632c5.48,4.401,10.96,8.802,16.441,13.203 c8.656,6.952,17.313,13.903,25.969,20.855c1.996,1.603,3.992,3.206,5.989,4.809c1.052,0.845,2.508,1.028,3.536,0 c0.875-0.875,1.058-2.686,0-3.535c-5.48-4.401-10.96-8.802-16.441-13.203c-8.656-6.952-17.313-13.903-25.969-20.855 c-1.996-1.603-3.992-3.206-5.989-4.809c-1.052-0.845-2.508-1.028-3.536,0C234.313,406.971,234.129,408.782,235.187,409.632 L235.187,409.632z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 91.775,
    y: 52.628,
    style: {
      fill: "#FFFFFF"
    },
    width: 287.759,
    height: 217.828
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C4465"
    },
    d: "M379.534,269.832c-2.583,0-5.166,0-7.749,0c-6.967,0-13.933,0-20.9,0 c-10.329,0-20.657,0-30.986,0c-12.601,0-25.203,0-37.804,0c-13.754,0-27.508,0-41.262,0c-13.978,0-27.956,0-41.934,0 c-12.944,0-25.888,0-38.832,0c-10.978,0-21.956,0-32.934,0c-7.893,0-15.785,0-23.678,0c-2.448,0-4.896,0-7.343,0 c-1.253,0-2.602-0.142-3.848,0c-0.159,0.018-0.329,0-0.489,0c0.208,0.208,0.417,0.417,0.625,0.625c0-1.944,0-3.888,0-5.833 c0-5.291,0-10.582,0-15.872c0-7.785,0-15.57,0-23.355c0-9.54,0-19.079,0-28.618c0-10.451,0-20.903,0-31.354 c0-10.55,0-21.1,0-31.65c0-9.795,0-19.589,0-29.384c0-8.318,0-16.636,0-24.954c0-5.982,0-11.964,0-17.946 c0-1.861,0-3.722,0-5.583c0-0.916,0.166-2.012,0-2.917c-0.021-0.113,0-0.247,0-0.363c-0.208,0.208-0.417,0.417-0.625,0.625 c2.583,0,5.166,0,7.749,0c6.967,0,13.933,0,20.9,0c10.329,0,20.657,0,30.986,0c12.601,0,25.203,0,37.804,0 c13.754,0,27.508,0,41.262,0c13.978,0,27.956,0,41.934,0c12.944,0,25.888,0,38.833,0c10.978,0,21.956,0,32.933,0 c7.893,0,15.785,0,23.678,0c2.448,0,4.896,0,7.343,0c1.253,0,2.601,0.142,3.848,0c0.159-0.018,0.329,0,0.489,0 c-0.208-0.208-0.417-0.417-0.625-0.625c0,1.944,0,3.888,0,5.833c0,5.291,0,10.582,0,15.872c0,7.785,0,15.57,0,23.355 c0,9.539,0,19.079,0,28.619c0,10.451,0,20.902,0,31.354c0,10.55,0,21.1,0,31.65c0,9.795,0,19.589,0,29.384 c0,8.318,0,16.636,0,24.954c0,5.982,0,11.964,0,17.946c0,2.824-0.121,5.678,0,8.499c0.005,0.121,0,0.242,0,0.363 c0,0.804,1.25,0.806,1.25,0c0-1.944,0-3.888,0-5.833c0-5.291,0-10.582,0-15.872c0-7.785,0-15.57,0-23.355 c0-9.54,0-19.079,0-28.618c0-10.451,0-20.903,0-31.354c0-10.55,0-21.1,0-31.65c0-9.795,0-19.589,0-29.384 c0-8.318,0-16.636,0-24.954c0-5.982,0-11.964,0-17.946c0-2.823,0.121-5.678,0-8.499c-0.005-0.121,0-0.243,0-0.363 c0-0.338-0.286-0.625-0.625-0.625c-2.583,0-5.166,0-7.749,0c-6.967,0-13.933,0-20.9,0c-10.329,0-20.657,0-30.986,0 c-12.601,0-25.203,0-37.804,0c-13.754,0-27.508,0-41.262,0c-13.978,0-27.956,0-41.934,0c-12.944,0-25.888,0-38.832,0 c-10.978,0-21.956,0-32.934,0c-7.893,0-15.785,0-23.678,0c-3.729,0-7.463-0.058-11.192,0c-0.163,0.002-0.326,0-0.489,0 c-0.338,0-0.625,0.286-0.625,0.625c0,1.944,0,3.888,0,5.833c0,5.291,0,10.582,0,15.872c0,7.785,0,15.57,0,23.355 c0,9.539,0,19.079,0,28.619c0,10.451,0,20.902,0,31.354c0,10.55,0,21.1,0,31.65c0,9.795,0,19.589,0,29.384 c0,8.318,0,16.636,0,24.954c0,5.982,0,11.964,0,17.946c0,2.824-0.121,5.678,0,8.499c0.005,0.121,0,0.242,0,0.363 c0,0.338,0.286,0.625,0.625,0.625c2.583,0,5.166,0,7.749,0c6.967,0,13.933,0,20.9,0c10.329,0,20.657,0,30.986,0 c12.601,0,25.203,0,37.804,0c13.754,0,27.508,0,41.262,0c13.978,0,27.956,0,41.934,0c12.944,0,25.888,0,38.833,0 c10.978,0,21.956,0,32.933,0c7.893,0,15.785,0,23.678,0c3.729,0,7.463,0.058,11.192,0c0.163-0.003,0.326,0,0.489,0 C380.338,271.082,380.34,269.832,379.534,269.832z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#96AACC",
      strokeMiterlimit: 10
    },
    x1: 156.554,
    y1: 96.559,
    x2: 156.554,
    y2: 231.139
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#96AACC",
      strokeMiterlimit: 10
    },
    x1: 196.104,
    y1: 96.559,
    x2: 196.104,
    y2: 231.139
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#96AACC",
      strokeMiterlimit: 10
    },
    x1: 235.654,
    y1: 96.559,
    x2: 235.654,
    y2: 231.139
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#96AACC",
      strokeMiterlimit: 10
    },
    x1: 275.205,
    y1: 96.559,
    x2: 275.205,
    y2: 231.139
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#96AACC",
      strokeMiterlimit: 10
    },
    x1: 314.755,
    y1: 96.559,
    x2: 314.755,
    y2: 231.139
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#96AACC",
      strokeMiterlimit: 10
    },
    x1: 121.418,
    y1: 134.168,
    x2: 349.891,
    y2: 134.168
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#96AACC",
      strokeMiterlimit: 10
    },
    x1: 121.418,
    y1: 114.381,
    x2: 349.891,
    y2: 114.381
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#96AACC",
      strokeMiterlimit: 10
    },
    x1: 121.418,
    y1: 153.956,
    x2: 349.891,
    y2: 153.956
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#96AACC",
      strokeMiterlimit: 10
    },
    x1: 121.418,
    y1: 173.743,
    x2: 349.891,
    y2: 173.743
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#96AACC",
      strokeMiterlimit: 10
    },
    x1: 121.418,
    y1: 193.53,
    x2: 349.891,
    y2: 193.53
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#96AACC",
      strokeMiterlimit: 10
    },
    x1: 121.418,
    y1: 213.317,
    x2: 349.891,
    y2: 213.317
  })), /*#__PURE__*/React.createElement("rect", {
    x: 121.418,
    y: 96.559,
    style: {
      fill: "none",
      stroke: "#96AACC",
      strokeMiterlimit: 10
    },
    width: 228.472,
    height: 134.58
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AACC"
    },
    d: "M300.014,244.59H124.421c-1.658,0-3.002-1.344-3.002-3.002l0,0 c0-1.658,1.344-3.002,3.002-3.002h175.593c1.658,0,3.002,1.344,3.002,3.002l0,0 C303.016,243.246,301.672,244.59,300.014,244.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AACC"
    },
    d: "M262.967,253.119H123.116c-0.937,0-1.697-0.76-1.697-1.697l0,0c0-0.937,0.76-1.697,1.697-1.697 h139.851c0.937,0,1.697,0.76,1.697,1.697l0,0C264.664,252.359,263.904,253.119,262.967,253.119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96AACC"
    },
    d: "M276.532,84.813H136.681c-0.937,0-1.697-0.76-1.697-1.697l0,0c0-0.937,0.76-1.697,1.697-1.697 h139.851c0.937,0,1.697,0.76,1.697,1.697l0,0C278.229,84.053,277.47,84.813,276.532,84.813z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 243.264,
    y: 162.099,
    style: {
      fill: "#7B8FB4"
    },
    width: 27.041,
    height: 68.571
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.709,
    y: 180.63,
    style: {
      fill: "#7B8FB4"
    },
    width: 27.041,
    height: 50.779
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.709,
    y: 200.935,
    style: {
      fill: "#7B8FB4"
    },
    width: 27.041,
    height: 30.473
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.264,
    y: 143.733,
    style: {
      fill: "#7B8FB4"
    },
    width: 27.041,
    height: 86.937
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D46249"
    },
    d: "M143.081,195.671c5.507-5.788,11.014-11.576,16.521-17.364 c8.766-9.213,17.531-18.426,26.297-27.639c1.996-2.098,3.992-4.196,5.988-6.294c-0.442,0.183-0.884,0.366-1.326,0.549 c5.376,0,10.752,0,16.128,0c3.514,0,7.028,0,10.542,0c1.118,0,2.236,0,3.355,0c0.868,0,1.576,0.067,2.315-0.55 c0.9-0.752,1.689-1.71,2.512-2.543c2-2.024,3.999-4.048,5.999-6.072c5.422-5.488,10.843-10.975,16.265-16.463 c3.415-3.457,6.83-6.913,10.245-10.37c-0.442,0.183-0.884,0.366-1.326,0.549c8.533,0,17.065,0,25.598,0 c1.611,0,3.222,0,4.833,0c1.022,0,1.757-0.302,2.425-1.078c2.952-3.431,5.904-6.861,8.856-10.291 c2.724-3.165,5.448-6.331,8.172-9.496c1.567-1.821-1.074-4.485-2.652-2.652c-5.102,5.929-10.205,11.859-15.307,17.789 c-0.725,0.843-1.45,1.685-2.175,2.528c0.442-0.183,0.884-0.366,1.326-0.549c-5.387,0-10.773,0-16.16,0 c-3.521,0-7.042,0-10.563,0c-1.12,0-2.241,0-3.361,0c-0.868,0-1.578-0.068-2.317,0.55c-0.9,0.752-1.689,1.71-2.512,2.543 c-2,2.024-3.999,4.048-5.999,6.072c-5.422,5.488-10.843,10.976-16.265,16.463c-3.415,3.457-6.83,6.913-10.245,10.37 c0.442-0.183,0.884-0.366,1.326-0.549c-7.308,0-14.615,0-21.922,0c-2.976,0-5.99-0.142-8.964,0 c-1.43,0.068-2.406,1.551-3.321,2.512c-5.104,5.364-10.208,10.729-15.312,16.094c-6.66,7-13.321,14.001-19.981,21.001 c-3.818,4.013-7.749,7.946-11.467,12.052c-0.058,0.064-0.119,0.125-0.178,0.187 C138.766,194.767,141.413,197.423,143.081,195.671L143.081,195.671z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D46249"
    },
    d: "M307.5,81.514l-15.977,6.599c-1.336,0.552-1.574,2.343-0.428,3.225l13.704,10.537 c1.146,0.881,2.816,0.191,3.007-1.242l2.273-17.136C310.269,82.063,308.837,80.962,307.5,81.514z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#647853"
    },
    d: "M113.464,276.762c2.123-4.256,2.66-9.307,1.094-14.194 c-2.053-6.407-7.211-10.94-13.276-12.511c1.41-3.023,1.743-6.559,0.645-9.986c-2.314-7.22-10.044-11.198-17.264-8.884 c-7.221,2.314-11.198,10.044-8.884,17.264c1.098,3.427,3.424,6.111,6.329,7.75c-4.022,4.803-5.583,11.49-3.53,17.897 c1.566,4.887,4.94,8.685,9.141,10.913c-5.581,6.547-7.751,15.743-4.932,24.538c4.333,13.518,18.804,20.965,32.322,16.632 c13.518-4.333,20.965-18.804,16.632-32.322C128.922,285.065,121.811,278.845,113.464,276.762z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M130.288,372.652c-1.501-4.685-3.003-9.37-4.505-14.055 c-3.619-11.291-7.238-22.582-10.857-33.873c-4.366-13.62-8.731-27.241-13.097-40.861c-3.782-11.8-7.564-23.6-11.346-35.401 c-1.241-3.87-2.481-7.741-3.722-11.612c-0.583-1.819-1.075-3.705-1.759-5.49c-0.029-0.075-0.05-0.155-0.074-0.232 c-0.244-0.763-1.452-0.437-1.205,0.332c1.502,4.685,3.003,9.37,4.505,14.054c3.619,11.291,7.238,22.582,10.857,33.873 c4.366,13.62,8.731,27.241,13.097,40.861c3.782,11.8,7.564,23.601,11.346,35.401c1.241,3.871,2.481,7.741,3.722,11.612 c0.583,1.819,1.075,3.705,1.759,5.49c0.029,0.075,0.05,0.155,0.074,0.232C129.327,373.748,130.535,373.422,130.288,372.652 L130.288,372.652z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M81.489,304.534c8.617,3.271,17.235,6.541,25.853,9.812 c1.231,0.467,2.462,0.934,3.693,1.401c0.753,0.286,1.078-0.922,0.332-1.205c-8.618-3.271-17.235-6.541-25.853-9.812 c-1.231-0.467-2.462-0.934-3.693-1.402C81.068,303.043,80.743,304.251,81.489,304.534L81.489,304.534z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M106.942,300.491c3.023-6.528,6.047-13.056,9.07-19.585 c0.427-0.922,0.854-1.845,1.281-2.767c0.336-0.725-0.741-1.361-1.079-0.631c-3.023,6.528-6.047,13.056-9.07,19.585 c-0.427,0.922-0.854,1.845-1.281,2.767C105.527,300.585,106.604,301.221,106.942,300.491L106.942,300.491z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M77.412,267.507c6.162,2.82,12.325,5.641,18.487,8.462c0.882,0.404,1.763,0.807,2.645,1.211 c0.726,0.332,1.362-0.745,0.631-1.079c-6.162-2.82-12.325-5.641-18.487-8.461c-0.882-0.404-1.763-0.807-2.645-1.211 C77.316,266.095,76.68,267.172,77.412,267.507L77.412,267.507z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M92.644,255.534c1.97-5.997,3.94-11.994,5.91-17.992c0.283-0.86,0.565-1.721,0.848-2.581 c0.252-0.766-0.955-1.094-1.205-0.332c-1.97,5.997-3.94,11.995-5.91,17.992c-0.283,0.86-0.565,1.721-0.848,2.581 C91.187,255.967,92.394,256.296,92.644,255.534L92.644,255.534z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#647853"
    },
    d: "M159.86,297.508c-1.471-3.669-1.575-7.89,0.053-11.832c2.134-5.169,6.712-8.575,11.842-9.467 c-0.964-2.599-1.001-5.551,0.14-8.315c2.405-5.825,9.076-8.598,14.901-6.193c5.825,2.405,8.598,9.076,6.193,14.901 c-1.141,2.765-3.249,4.83-5.767,5.993c3.007,4.251,3.849,9.895,1.715,15.064c-1.627,3.942-4.678,6.861-8.309,8.423 c4.181,5.801,5.358,13.564,2.429,20.659c-4.502,10.906-16.993,16.097-27.898,11.595s-16.097-16.993-11.595-27.898 C146.494,303.343,152.805,298.67,159.86,297.508z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M142.763,370.76c1.488-3.605,2.977-7.21,4.465-10.816 c3.574-8.658,7.149-17.317,10.723-25.975c4.324-10.476,8.649-20.951,12.974-31.427c3.739-9.057,7.478-18.114,11.217-27.171 c1.232-2.985,2.465-5.97,3.697-8.956c0.571-1.383,1.346-2.809,1.755-4.251c0.018-0.063,0.052-0.125,0.077-0.186 c0.307-0.743-0.902-1.067-1.205-0.332c-1.488,3.605-2.977,7.21-4.465,10.815c-3.574,8.658-7.149,17.317-10.723,25.975 c-4.325,10.476-8.649,20.951-12.974,31.427c-3.739,9.057-7.478,18.114-11.217,27.171c-1.232,2.985-2.465,5.971-3.697,8.956 c-0.571,1.383-1.346,2.809-1.755,4.251c-0.018,0.063-0.052,0.125-0.077,0.186 C141.251,371.171,142.46,371.495,142.763,370.76L142.763,370.76z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M184.209,321.56c-7.355,2.126-14.711,4.252-22.066,6.378 c-1.055,0.305-2.111,0.61-3.166,0.915c-0.771,0.223-0.443,1.429,0.332,1.205c7.355-2.126,14.711-4.252,22.066-6.378 c1.055-0.305,2.111-0.61,3.166-0.915C185.313,322.543,184.985,321.336,184.209,321.56L184.209,321.56z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M164.731,317.215c-2.059-5.599-4.117-11.198-6.176-16.796 c-0.296-0.806-0.593-1.612-0.889-2.418c-0.275-0.749-1.484-0.425-1.205,0.332c2.059,5.599,4.117,11.198,6.176,16.796 c0.296,0.806,0.593,1.612,0.889,2.418C163.801,318.296,165.01,317.972,164.731,317.215L164.731,317.215z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M189.959,291.206c-5.291,1.919-10.582,3.837-15.873,5.756 c-0.762,0.276-1.524,0.552-2.285,0.829c-0.75,0.272-0.426,1.48,0.332,1.205c5.291-1.919,10.582-3.837,15.873-5.756 c0.762-0.276,1.524-0.552,2.285-0.829C191.042,292.139,190.718,290.93,189.959,291.206L189.959,291.206z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M179.654,281.067c-1.23-5.114-2.46-10.228-3.69-15.342 c-0.173-0.719-0.346-1.438-0.519-2.156c-0.188-0.782-1.394-0.451-1.205,0.332c1.23,5.114,2.46,10.228,3.69,15.342 c0.173,0.719,0.346,1.438,0.519,2.156C178.637,282.181,179.842,281.85,179.654,281.067L179.654,281.067z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C4465"
    },
    points: "180.185,365.714 162.754,449.097 107.386,449.097 90.98,365.714  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B8FB4"
    },
    d: "M94.805,385.78c9.128,0,18.256,0,27.384,0c14.549,0,29.098,0,43.646,0 c3.339,0,6.679,0,10.018,0c0.804,0,0.806-1.25,0-1.25c-9.128,0-18.256,0-27.383,0c-14.549,0-29.098,0-43.646,0 c-3.34,0-6.679,0-10.018,0C94.001,384.53,94,385.78,94.805,385.78L94.805,385.78z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9374"
    },
    points: "317.563,412.704 326.859,384.837 342.995,391.03 333.501,419.492  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#36303A"
    },
    points: "275.536,430.514 329.49,448.104 338.696,415.806 312.831,409.245 307.983,421.46  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#263238"
    },
    x1: 295.76,
    y1: 422.204,
    x2: 296.664,
    y2: 430.683
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B8FB4"
    },
    d: "M295.385,422.204c0.264,2.47,0.527,4.941,0.791,7.411 c0.038,0.356,0.076,0.711,0.114,1.067c0.051,0.475,0.801,0.48,0.75,0c-0.264-2.47-0.527-4.941-0.791-7.411 c-0.038-0.356-0.076-0.711-0.114-1.067C296.084,421.729,295.333,421.724,295.385,422.204L295.385,422.204z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#263238"
    },
    x1: 301.608,
    y1: 421.115,
    x2: 302.513,
    y2: 429.592
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B8FB4"
    },
    d: "M301.233,421.115c0.264,2.47,0.527,4.941,0.791,7.411 c0.038,0.356,0.076,0.711,0.114,1.067c0.051,0.475,0.801,0.48,0.75,0c-0.264-2.47-0.527-4.941-0.791-7.411 c-0.038-0.356-0.076-0.711-0.114-1.067C301.933,420.639,301.182,420.634,301.233,421.115L301.233,421.115z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B8FB4"
    },
    d: "M305.986,420.964c-1.524-1.288-2.971-2.682-4.343-4.128 c-1.125-1.185-2.212-2.423-3.136-3.773c-0.692-1.01-1.474-2.22-1.552-3.48c-0.065-1.05,0.703-1.836,1.669-2.153 c0.898-0.295,1.693,0.175,2.298,0.82c1.773,1.892,2.547,4.81,3.202,7.246c0.515,1.916,0.945,3.87,1.237,5.833 c0.071,0.476,0.793,0.273,0.723-0.199c-0.27-1.815-0.661-3.62-1.121-5.395c-0.694-2.678-1.526-5.764-3.396-7.889 c-0.662-0.752-1.571-1.355-2.613-1.248c-1.037,0.107-2.202,0.883-2.585,1.869c-0.433,1.115,0.029,2.372,0.534,3.38 c0.733,1.464,1.776,2.777,2.842,4.012c1.743,2.019,3.674,3.914,5.712,5.636 C305.823,421.804,306.356,421.276,305.986,420.964z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B8FB4"
    },
    d: "M306.605,406.82c-0.281,4.307-0.563,8.613-0.845,12.92 c-0.04,0.62-0.081,1.24-0.121,1.86c-0.031,0.482,0.719,0.48,0.75,0c0.281-4.307,0.563-8.613,0.844-12.92 c0.04-0.62,0.081-1.24,0.122-1.86C307.387,406.338,306.637,406.34,306.605,406.82L306.605,406.82z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C4465"
    },
    d: "M363.102,226.819c0,0-7.965,19.801-10.037,26.6 c-10.158,33.322-31.897,135.643-31.897,135.643l24.313,9.58l71.61-163.799L363.102,226.819z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B8FB4"
    },
    d: "M321.002,389.664c7.076,2.788,14.151,5.576,21.227,8.364 c1.029,0.405,2.057,0.811,3.086,1.216c0.234,0.092,0.6-0.057,0.706-0.287c3.904-8.478,7.807-16.956,11.71-25.434 c6.218-13.505,12.436-27.01,18.654-40.515c1.422-3.089,2.844-6.178,4.266-9.267c0.334-0.726-0.743-1.362-1.079-0.631 c-3.903,8.478-7.807,16.956-11.71,25.434c-6.218,13.505-12.436,27.01-18.654,40.515c-1.422,3.089-2.844,6.178-4.267,9.267 c0.235-0.096,0.471-0.191,0.706-0.287c-7.076-2.788-14.151-5.576-21.227-8.364c-1.029-0.405-2.057-0.811-3.086-1.216 C320.586,388.164,320.261,389.372,321.002,389.664L321.002,389.664z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9374"
    },
    points: "394.699,417.694 394.712,388.315 413.821,387.451 412.022,417.537  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#36303A"
    },
    points: "361.904,448.477 418.651,448.944 417.669,415.374 391.031,416.934 390.099,430.042  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#263238"
    },
    x1: 378.672,
    y1: 434.445,
    x2: 382.096,
    y2: 442.254
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B8FB4"
    },
    d: "M378.349,434.635c1,2.282,2.001,4.563,3.001,6.845c0.141,0.321,0.282,0.642,0.422,0.964 c0.193,0.441,0.84,0.06,0.648-0.379c-1-2.282-2.001-4.563-3.001-6.845c-0.141-0.321-0.282-0.642-0.423-0.964 C378.803,433.815,378.156,434.197,378.349,434.635L378.349,434.635z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#263238"
    },
    x1: 383.918,
    y1: 431.639,
    x2: 387.342,
    y2: 439.448
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B8FB4"
    },
    d: "M383.595,431.829c1,2.282,2.001,4.563,3.001,6.845c0.141,0.321,0.282,0.642,0.422,0.964 c0.193,0.441,0.84,0.06,0.648-0.379c-1-2.282-2.001-4.563-3.001-6.845c-0.141-0.321-0.282-0.642-0.423-0.964 C384.049,431.009,383.402,431.391,383.595,431.829L383.595,431.829z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B8FB4"
    },
    d: "M387.974,430.144c-0.091-0.038,0.086,0.037-0.043-0.018 c-0.118-0.05-0.235-0.101-0.352-0.152c-0.394-0.172-0.785-0.35-1.175-0.53c-1.246-0.578-2.474-1.194-3.677-1.856 c-1.374-0.757-2.727-1.572-3.98-2.518c-0.999-0.754-2.085-1.647-2.649-2.793c-0.482-0.981-0.15-1.898,0.638-2.613 c0.716-0.65,1.612-0.605,2.438-0.188c1.088,0.549,1.976,1.473,2.766,2.382c0.952,1.096,1.79,2.288,2.577,3.507 c1.107,1.715,2.138,3.497,3.035,5.332c0.212,0.434,0.859,0.054,0.648-0.379c-0.834-1.707-1.788-3.366-2.804-4.971 c-0.83-1.311-1.719-2.592-2.72-3.78c-0.85-1.009-1.814-2.027-2.985-2.667c-0.904-0.494-1.97-0.707-2.913-0.187 c-0.925,0.51-1.735,1.642-1.677,2.725c0.066,1.243,1.006,2.307,1.866,3.116c1.183,1.112,2.558,2.024,3.946,2.857 c2.192,1.315,4.503,2.475,6.863,3.458C388.219,431.053,388.413,430.328,387.974,430.144z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B8FB4"
    },
    d: "M384.359,416.49c1.036,4.203,2.072,8.406,3.108,12.609 c0.146,0.591,0.291,1.181,0.437,1.772c0.115,0.468,0.839,0.27,0.723-0.199c-1.036-4.203-2.072-8.406-3.108-12.609 c-0.146-0.591-0.291-1.181-0.437-1.772C384.967,415.822,384.243,416.02,384.359,416.49L384.359,416.49z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C4465"
    },
    d: "M370.549,244.259l17.993,150.324l28.052-1.02c0,0,8.797-96.702,7.711-129.648 c-0.262-7.936-6.417-33.493-6.417-33.493L370.549,244.259z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B8FB4"
    },
    d: "M402.785,394.088c-0.33-5.158-0.66-10.316-0.991-15.475 c-0.79-12.341-1.58-24.682-2.37-37.023c-0.958-14.961-1.916-29.922-2.874-44.883c-0.825-12.885-1.65-25.771-2.475-38.656 c-0.399-6.228-0.552-12.53-1.2-18.739c-0.009-0.084-0.011-0.17-0.016-0.255c-0.051-0.799-1.301-0.805-1.25,0 c0.33,5.158,0.66,10.316,0.991,15.475c0.79,12.341,1.58,24.682,2.37,37.023c0.958,14.961,1.916,29.922,2.874,44.883 c0.825,12.885,1.65,25.771,2.475,38.656c0.399,6.228,0.552,12.53,1.2,18.739c0.009,0.084,0.011,0.17,0.016,0.255 C401.586,394.887,402.837,394.893,402.785,394.088L402.785,394.088z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B8FB4"
    },
    d: "M372.205,261.96c0.523,4.419,1.047,8.838,1.571,13.257 c1.247,10.525,2.494,21.051,3.741,31.576c1.517,12.808,3.035,25.616,4.552,38.424c1.303,11.003,2.607,22.005,3.91,33.008 c0.635,5.362,1.054,10.805,1.912,16.138c0.012,0.073,0.017,0.147,0.026,0.22c0.039,0.326,0.255,0.638,0.625,0.625 c8.202-0.298,16.404-0.596,24.607-0.895c1.148-0.042,2.297-0.083,3.445-0.125c0.802-0.029,0.806-1.279,0-1.25 c-8.202,0.298-16.404,0.596-24.607,0.895c-1.148,0.042-2.297,0.084-3.445,0.125c0.208,0.208,0.417,0.417,0.625,0.625 c-0.524-4.419-1.047-8.838-1.571-13.257c-1.247-10.525-2.494-21.051-3.741-31.576 c-1.517-12.808-3.035-25.616-4.552-38.424c-1.303-11.003-2.607-22.005-3.91-33.008 c-0.635-5.362-1.053-10.805-1.912-16.138c-0.012-0.073-0.017-0.147-0.026-0.22 C373.361,261.171,372.11,261.162,372.205,261.96L372.205,261.96z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B8FB4"
    },
    d: "M365.097,232.807c12.396,6.813,27.211,6.378,40.925,6.147c0.643-0.011,0.645-1.011,0-1 c-13.528,0.228-28.19,0.711-40.421-6.011C365.037,231.634,364.532,232.497,365.097,232.807L365.097,232.807z"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9374"
    },
    d: "M309.436,138.327l-1.877,0.805l-1.516-3.521c0,0-6.03-10.058-6.671-10.627 c-0.641-0.569-2.281-1.059-2.281-1.059s-2.249-3.353-3.923-6.084c-1.674-2.731-3.674-5.364-5.578-5.236 c-1.904,0.128-2.095,1.814-1.755,3.673c0.339,1.858,1.661,3.662,1.661,3.662s2.666,3.606,1.809,3.633 c-0.857,0.026-1.558,0.575-1.825,1.357c-0.304,0.891-0.366,1.05-0.86,1.194c-0.316,0.092-1.111,0.133-1.799,0.928 c-0.688,0.795-0.459,1.278-0.99,1.511c-0.53,0.233-2.198,0.868-1.683,3.189c0.515,2.322,2.458,3.826,3.524,4.816 c1.066,0.99,2.541,0.237,2.541,0.237s3.226,4.659,4.69,5.82c1.214,0.962,5.583,2.686,5.583,2.686s21.02,33.566,24.665,37.694 l16.198-16.048L309.436,138.327z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#905853"
    },
    d: "M290.098,123.208c-0.992-1.64-1.931-3.31-2.819-5.008c-0.298-0.571-1.161-0.066-0.863,0.505 c0.887,1.698,1.827,3.369,2.819,5.008C289.567,124.262,290.432,123.76,290.098,123.208L290.098,123.208z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#905853"
    },
    d: "M288.807,124.195c1.492-0.405,2.738,0.78,3.536,1.893c0.458,0.639,0.871,1.312,1.239,2.006 c0.326,0.615,0.717,1.317,0.697,2.035c-0.017,0.64-0.464,1.059-1.077,1.162c-0.658,0.11-1.284-0.184-1.813-0.548 c-1.212-0.834-2.216-2.068-2.998-3.3c-0.344-0.542-1.21-0.041-0.864,0.505c0.781,1.23,1.741,2.383,2.88,3.299 c1.015,0.816,2.318,1.401,3.599,0.835c1.332-0.59,1.472-2.068,1-3.296c-0.528-1.374-1.36-2.718-2.297-3.851 c-1.012-1.223-2.539-2.147-4.169-1.704C287.921,123.399,288.184,124.364,288.807,124.195L288.807,124.195z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#905853"
    },
    d: "M290.164,131.081c0.74,0.325,1.071,1.362,1.029,2.12c-0.048,0.871-0.955,1.312-1.74,1.208 c-0.984-0.131-1.742-0.879-2.322-1.628c-0.64-0.828-1.174-1.755-1.576-2.721c-0.103-0.248-0.332-0.429-0.615-0.349 c-0.235,0.066-0.454,0.363-0.349,0.615c0.403,0.97,0.896,1.891,1.514,2.742c0.594,0.816,1.288,1.615,2.227,2.037 c0.876,0.393,1.921,0.466,2.763-0.057c0.842-0.524,1.197-1.41,1.061-2.376c-0.134-0.949-0.547-2.039-1.487-2.451 c-0.249-0.109-0.534-0.071-0.684,0.179C289.858,130.608,289.917,130.973,290.164,131.081L290.164,131.081z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#905853"
    },
    d: "M288.224,134.965c0.147,0.98-0.702,1.992-1.716,1.543c-0.493-0.218-0.88-0.633-1.259-1.003 c-0.489-0.476-0.977-0.953-1.466-1.429c-0.461-0.45-1.169,0.257-0.707,0.707c0.597,0.582,1.186,1.173,1.793,1.745 c0.503,0.475,1.086,0.947,1.789,1.06c0.732,0.118,1.488-0.153,1.975-0.717c0.527-0.61,0.672-1.392,0.555-2.173 c-0.04-0.267-0.377-0.415-0.615-0.349C288.288,134.429,288.184,134.697,288.224,134.965L288.224,134.965z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9374"
    },
    d: "M297.803,125.525c0,0-0.939,1.174-3.191,2.379c-2.251,1.206-4.79,0.957-4.679-1.099 c0.111-2.057,3.545-3.929,4.606-4.522s2.029-1.08,2.888-0.722c0.753,0.313,2.645,1.539,4.94,4.781 c2.295,3.242,9.581,15.084,9.581,15.084l-4.668,3.714L297.803,125.525z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#905853"
    },
    d: "M296.103,121.107c-2.226,0.864-4.502,1.952-5.959,3.919 c-0.696,0.94-1.151,2.328-0.377,3.369c0.777,1.046,2.173,1.179,3.333,0.782c1.514-0.518,2.924-1.503,4.203-2.444 c0.513-0.377,0.014-1.246-0.505-0.863c-0.983,0.724-2.011,1.391-3.094,1.955c-0.864,0.451-2.06,0.921-2.922,0.204 c-0.829-0.69-0.273-1.849,0.253-2.534c0.608-0.792,1.403-1.426,2.249-1.947c0.973-0.6,2.021-1.064,3.085-1.477 C296.963,121.841,296.705,120.874,296.103,121.107L296.103,121.107z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9DCD2"
    },
    d: "M307.326,178.264c0,0-2.71-4.187-0.704-6.618c2.006-2.43,23.31-21.49,25.473-21.288 c2.163,0.202,10.605,8.994,10.578,9.823c-0.027,0.829-0.42,1.713-0.42,1.713s12.053,4.625,26.656-3.229 c2.895-1.557,8.839-4.669,13.233-5.826l-16.391,51.708c0,0-28.089,5.346-53.771-22.743 C311.981,181.804,309.33,182.276,307.326,178.264z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#81524E"
    },
    d: "M332.121,157.081c-5.524,5.045-11.047,10.089-16.571,15.134 c-0.789,0.72-1.577,1.44-2.366,2.161c-0.525,0.48,0.153,1.35,0.757,0.982c2.467-1.504,4.999-2.91,7.554-4.258 c4.315-2.278,8.815-4.579,13.574-5.766c0.78-0.195,0.45-1.4-0.332-1.205c-4.773,1.191-9.305,3.492-13.638,5.769 c-2.635,1.385-5.246,2.831-7.788,4.381c0.252,0.327,0.505,0.654,0.757,0.982c5.524-5.045,11.047-10.089,16.571-15.134 c0.788-0.72,1.577-1.44,2.366-2.161C333.6,157.421,332.714,156.539,332.121,157.081L332.121,157.081z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#81524E"
    },
    d: "M322.122,191.984c2.14,1.846,4.572,3.408,6.998,4.842c5.622,3.322,11.752,5.86,18.119,7.328 c4.509,1.04,9.132,1.523,13.758,1.413c0.803-0.019,0.806-1.269,0-1.25c-12.777,0.302-25.51-4.129-35.843-11.563 c-0.733-0.527-1.465-1.065-2.149-1.654C322.4,190.578,321.512,191.458,322.122,191.984L322.122,191.984z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9374"
    },
    d: "M401.637,135.236c0.055-0.31,0.101-0.623,0.131-0.942l1.058-11.321 c0.517-5.528-3.034-10.422-7.889-10.876l-7.303-0.682c-4.855-0.454-9.25,3.698-9.767,9.226l-1.058,11.321 c-0.517,5.528,3.034,10.422,7.889,10.876l2.462,0.23l-0.238,10.012l4.54,1c0.323,0.108,0.659,0.19,1.012,0.223l2.897,0.271 c0.719,0.067,1.409-0.055,2.044-0.299l0.037,0l0-0.016c1.552-0.613,2.725-2.04,2.89-3.807l0.644-6.892l0.036-0.384 l0.644-6.892C401.698,135.928,401.685,135.577,401.637,135.236z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36303A"
    },
    d: "M400.197,130.453l-0.52-8.994c0,0-24.821,0.783-31.661-11.877 c-6.84-12.66,1.959-16.598,5.94-15.546c3.981,1.052,8.168,7.29,8.168,7.29s-3.503-6.323,0.72-7.706 c3.675-1.203,8.796,3.169,10.371,8.759c0,0,15.197,1.106,19.75,11.402c4.553,10.296-0.526,16.824-11.47,26l-0.384-5.74 L400.197,130.453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36303A"
    },
    d: "M441.483,107.17c-0.715,7.647-7.493,13.268-15.14,12.553 c-7.647-0.715-13.268-7.493-12.553-15.14c0.715-7.647,7.493-13.268,15.14-12.553 C436.577,92.744,442.198,99.523,441.483,107.17z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36303A"
    },
    d: "M392.135,125.706c-0.085,0.909-0.891,1.577-1.8,1.493c-0.909-0.085-1.577-0.891-1.492-1.8 c0.085-0.909,0.891-1.577,1.8-1.492C391.552,123.991,392.22,124.797,392.135,125.706z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36303A"
    },
    d: "M381.38,124.458c-0.073,0.776-0.761,1.346-1.536,1.274c-0.776-0.073-1.346-0.76-1.274-1.537 c0.072-0.776,0.76-1.346,1.536-1.274C380.882,122.994,381.453,123.682,381.38,124.458z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M382.323,131.34c0,0,0.602,2.488,2.336,2.817c1.733,0.329,3.285-1.481,3.521-2.985 L382.323,131.34z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EA8060"
    },
    d: "M397.07,132.036c-0.216,2.114-2.105,3.653-4.22,3.437c-2.114-0.216-3.653-2.105-3.437-4.219 c0.216-2.114,2.105-3.653,4.219-3.437C395.747,128.033,397.286,129.922,397.07,132.036z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EA8060"
    },
    d: "M377.946,127.478c-0.233-0.024-0.462-0.017-0.684,0.013l-0.406,3.971 c-0.061,0.593-0.097,1.169-0.034,1.74c0.157,0.043,0.361,0.087,0.528,0.104c1.609,0.165,3.047-1.007,3.212-2.616 C380.727,129.081,379.555,127.643,377.946,127.478z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7B8FB4",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: "M397.25,125.57 c-0.312,3.336-2.829,5.83-5.622,5.569c-2.793-0.261-4.805-3.177-4.493-6.514c0.312-3.337,2.829-5.83,5.622-5.569 C395.55,119.317,397.561,122.233,397.25,125.57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7B8FB4",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: "M384.096,123.759 c-0.292,3.128-2.546,5.475-5.034,5.243c-2.488-0.232-4.268-2.957-3.975-6.085s2.546-5.476,5.034-5.243 C382.608,117.906,384.388,120.631,384.096,123.759z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#7B8FB4",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 397.25,
    y1: 125.57,
    x2: 403.645,
    y2: 127.685
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#905853"
    },
    d: "M385.048,122.762c-0.496,1.507-1.292,2.905-2.34,4.097 c-0.212,0.241-0.189,0.612,0.101,0.785c0.715,0.426,1.431,0.853,2.146,1.279c0.554,0.33,1.058-0.534,0.505-0.863 c-0.715-0.426-1.431-0.853-2.146-1.279c0.034,0.262,0.068,0.524,0.101,0.785c1.165-1.326,2.046-2.861,2.597-4.538 C386.213,122.415,385.248,122.152,385.048,122.762L385.048,122.762z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B8FB4"
    },
    d: "M386.875,125.573c-1.688-1.141-3.308-0.385-3.359-0.352l0.101-0.637 c0.068-0.048,1.546-1.151,3.713,0.313L386.875,125.573z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36303A"
    },
    d: "M378.966,121.828c1.036-0.168,2.071-0.336,3.107-0.504 c0.259-0.042,0.426-0.377,0.349-0.615c-0.091-0.281-0.338-0.394-0.615-0.349c-1.036,0.168-2.072,0.336-3.107,0.504 c-0.259,0.042-0.426,0.377-0.349,0.615C378.441,121.759,378.688,121.873,378.966,121.828L378.966,121.828z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36303A"
    },
    d: "M390.221,122.56c1.278,0.404,2.557,0.807,3.835,1.211c0.257,0.081,0.545-0.096,0.615-0.349 c0.074-0.269-0.091-0.534-0.349-0.615c-1.278-0.404-2.557-0.807-3.835-1.211c-0.257-0.081-0.545,0.096-0.615,0.349 C389.798,122.214,389.963,122.478,390.221,122.56L390.221,122.56z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9374"
    },
    d: "M411.293,131.677c-0.298,3.185-3.142,5.524-6.353,5.224c-3.211-0.3-5.573-3.125-5.276-6.31 c0.298-3.185,3.142-5.524,6.353-5.224C409.228,125.667,411.59,128.492,411.293,131.677z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#905853"
    },
    d: "M402.675,131.602c0.001-0.035,0.004-0.069,0.007-0.104c0.003-0.036,0.007-0.071,0.01-0.107 c0.002-0.021,0.008-0.044,0.008-0.065c-0.001,0.085-0.012,0.076,0,0.003c0.049-0.295,0.118-0.585,0.221-0.866 c0.013-0.034,0.026-0.068,0.039-0.102c0.042-0.111-0.026,0.052,0.024-0.056c0.041-0.088,0.082-0.175,0.129-0.26 c0.043-0.079,0.09-0.156,0.139-0.231c0.028-0.043,0.058-0.084,0.087-0.126c0.043-0.061,0-0.001-0.008,0.009 c0.023-0.029,0.046-0.057,0.069-0.085c0.065-0.077,0.134-0.151,0.208-0.22c0.032-0.03,0.064-0.059,0.097-0.087 c0.025-0.021,0.05-0.042,0.076-0.063c-0.056,0.044-0.005,0.004,0.023-0.016c0.085-0.059,0.172-0.115,0.263-0.164 c0.052-0.028,0.106-0.054,0.16-0.08c0.013-0.006,0.072-0.031,0.002-0.002c0.034-0.014,0.069-0.028,0.105-0.04 c0.61-0.219,1.241-0.204,1.911-0.071c0.219,0.043,0.446-0.063,0.508-0.288c0.056-0.203-0.069-0.464-0.288-0.508 c-1.226-0.244-2.557-0.144-3.487,0.779c-0.574,0.57-0.914,1.358-1.055,2.146c-0.035,0.198-0.067,0.401-0.073,0.603 C401.834,132.133,402.659,132.133,402.675,131.602L402.675,131.602z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9DCD2"
    },
    d: "M422.608,180.192c0,0-1.738,34.358-2.892,43.215c-1.155,8.857-5.671,11.664-5.671,11.664 s-30.902-1.959-40.869-3.818c-9.967-1.859-12.857-5.999-12.738-12.532c0.12-6.533,2.486-38.869,2.486-38.869 s2.088-24.952,27.247-29.388l9.982,0.822C400.152,151.285,420.921,158.548,422.608,180.192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9374"
    },
    d: "M399.684,150.729c0,0,4.309,3.13,4.124,4.994c-0.184,1.864-14.524,14.389-14.524,14.389 l-7.141-17.272c0,0,5.316-2.598,8.389-2.802C393.605,149.833,399.096,150.248,399.684,150.729z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#81524E"
    },
    d: "M404.66,232.728c6.067-3.02,10.779-8.401,13.034-14.784c0.268-0.76-0.939-1.087-1.205-0.332 c-2.15,6.086-6.688,11.164-12.46,14.037C403.309,232.007,403.941,233.086,404.66,232.728L404.66,232.728z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#81524E"
    },
    d: "M421.983,180.192c-0.481,9.501-1.018,19-1.657,28.491 c-0.353,5.244-0.472,10.656-1.411,15.838c-0.577,3.185-1.778,6.503-4.189,8.771c-0.347,0.326-0.712,0.598-1.109,0.855 c0.126-0.081,0.318-0.049,0.051-0.048c-2.249,0.011-4.487,0.201-6.746,0.143c-6.241-0.161-12.472-0.775-18.668-1.516 c-5.117-0.612-10.242-1.286-15.324-2.143c-3.507-0.592-7.446-1.655-9.794-4.535c-3.036-3.723-2.027-9.325-1.773-13.768 c0.605-10.583,1.369-21.158,2.137-31.731c0.017-0.233,0.034-0.466,0.051-0.699c0.059-0.803-1.191-0.799-1.25,0 c-0.719,9.826-1.414,19.655-2.014,29.488c-0.151,2.48-0.3,4.96-0.407,7.442c-0.102,2.366-0.161,4.779,0.633,7.047 c2.755,7.871,13.046,8.165,19.912,9.127c7.652,1.072,15.345,1.992,23.065,2.399c3.168,0.167,6.379,0.301,9.547,0.053 c2.114-0.166,3.461-1.95,4.55-3.673c3.141-4.97,3.136-11.411,3.568-17.104c0.851-11.22,1.464-22.461,2.043-33.698 c0.013-0.247,0.025-0.493,0.038-0.74C423.273,179.388,422.023,179.391,421.983,180.192L421.983,180.192z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9374"
    },
    d: "M451.394,201.133l-18.041,19c-7.144,9.212-17.241,15.38-23.977,19.367l5.441,16.517 c0.61-0.189-0.919,0.47-0.236,0.121c11.439-5.837,42.365-25.825,44.888-31.985 C461.992,217.994,451.394,201.133,451.394,201.133z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#775860"
    },
    points: "413.922,236.719 418.462,233.507 429.285,247.543 424.856,250.16  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M425.608,242.021c-0.062,2.181-1.88,3.898-4.061,3.837c-2.181-0.062-3.898-1.88-3.837-4.061 c0.062-2.181,1.88-3.898,4.061-3.837C423.953,238.022,425.67,239.84,425.608,242.021z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36303A"
    },
    d: "M424.983,242.021c-0.058,1.372-0.958,2.62-2.278,3.046 c-1.326,0.427-2.815-0.007-3.675-1.115c-0.861-1.109-0.916-2.668-0.166-3.847c0.731-1.148,2.165-1.746,3.495-1.449 C423.937,239.01,425.007,240.418,424.983,242.021c-0.012,0.805,1.238,0.805,1.25,0c0.028-1.908-1.116-3.647-2.887-4.361 c-1.761-0.71-3.883-0.21-5.125,1.234c-1.253,1.457-1.494,3.571-0.551,5.257c0.941,1.681,2.863,2.561,4.749,2.267 c2.161-0.338,3.724-2.248,3.814-4.396C426.267,241.217,425.017,241.218,424.983,242.021z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B8FB4"
    },
    d: "M408.284,237.632c2.712,8.978,5.856,17.818,9.423,26.491c0.241,0.587,1.209,0.33,0.964-0.266 c-3.567-8.674-6.711-17.513-9.423-26.491C409.063,236.752,408.097,237.014,408.284,237.632L408.284,237.632z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9DCD2"
    },
    d: "M403.335,152.713c0,0,21.427,6.273,36.533,24.367c11.042,13.225,14.829,25.729,14.829,25.729 s3.243,1.137,5.015,3.183c1.772,2.046,3.513,10.607-3.32,13.109c-3.631,1.33-18.781,8.394-27.261,5.186 c-2.039-0.771-2.689-6.238-2.689-6.238l1.519-1.604l-21.042-16.202C406.919,200.243,408.563,161.732,403.335,152.713z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#81524E"
    },
    d: "M449.476,205.395c-6.014,3.935-11.854,8.128-17.512,12.56 c-0.484,0.379,0.041,1.268,0.608,1.045c6.373-2.508,12.837-4.775,19.381-6.795c0.766-0.237,0.439-1.444-0.332-1.205 c-6.544,2.021-13.008,4.287-19.381,6.795c0.203,0.348,0.405,0.696,0.608,1.045c5.574-4.366,11.335-8.488,17.26-12.364 C450.777,206.036,450.152,204.953,449.476,205.395L449.476,205.395z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#81524E"
    },
    d: "M411.568,204.192c2.929,1.797,5.647,4.007,8.359,6.108c2.701,2.092,5.508,4.161,7.971,6.537 c0.579,0.559,1.464-0.324,0.884-0.884c-1.815-1.751-3.85-3.297-5.826-4.858c-2.555-2.02-5.138-4.008-7.772-5.923 c-0.976-0.71-1.956-1.427-2.985-2.059C411.511,202.691,410.883,203.771,411.568,204.192L411.568,204.192z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#81524E"
    },
    d: "M376.761,158.683c3.16,7.058,6.32,14.116,9.479,21.174c0.447,0.999,0.895,1.999,1.342,2.998 c0.168,0.374,0.722,0.386,0.982,0.126c6.598-6.608,13.197-13.216,19.795-19.824c0.922-0.924,1.844-1.847,2.766-2.771 c0.569-0.57-0.314-1.454-0.884-0.884c-6.598,6.608-13.197,13.216-19.795,19.824c-0.922,0.924-1.844,1.847-2.766,2.771 c0.327,0.042,0.654,0.084,0.982,0.126c-3.16-7.058-6.32-14.116-9.479-21.174c-0.447-0.999-0.895-1.999-1.342-2.998 C377.512,157.319,376.435,157.954,376.761,158.683L376.761,158.683z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#81524E"
    },
    d: "M387.52,182.374c-2.055,13.887-3.074,27.888-4.896,41.803c-0.104,0.795,1.147,0.788,1.25,0 c1.807-13.804,2.813-27.694,4.852-41.47C388.842,181.919,387.637,181.579,387.52,182.374L387.52,182.374z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36303A"
    },
    d: "M459.962,447.915c-3.815,0-7.631,0-11.446,0c-10.29,0-20.58,0-30.87,0 c-15.256,0-30.512,0-45.767,0c-18.613,0-37.225,0-55.838,0c-20.315,0-40.63,0-60.945,0c-20.646,0-41.292,0-61.937,0 c-19.119,0-38.238,0-57.357,0c-16.215,0-32.429,0-48.644,0c-11.658,0-23.315,0-34.973,0c-5.507,0-11.024-0.096-16.531,0 c-0.241,0.004-0.482,0-0.723,0c-1.609,0-1.611,2.5,0,2.5c3.815,0,7.631,0,11.446,0c10.29,0,20.58,0,30.87,0 c15.256,0,30.512,0,45.767,0c18.613,0,37.225,0,55.838,0c20.315,0,40.63,0,60.945,0c20.646,0,41.292,0,61.937,0 c19.119,0,38.238,0,57.357,0c16.215,0,32.429,0,48.644,0c11.658,0,23.315,0,34.973,0c5.507,0,11.024,0.096,16.531,0 c0.241-0.004,0.482,0,0.723,0C461.571,450.415,461.574,447.915,459.962,447.915L459.962,447.915z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceTestPreState);
export default __webpack_public_path__ + "static/media/performance-test-pre-state.6dd6580559365c8ea2c6b9fca4c4fcc3.svg";
export { ForwardRef as ReactComponent };